const defaultOptions = {
    navigation: {
        prevEl: '.js-slider-teaser-prev',
        nextEl: '.js-slider-teaser-next',
        disabledClass: 'button--disabled',
    },
    spaceBetween: 24,
    slidesPerView: 'auto',
    watchSlidesVisibility: true,
};

const sliderTeaser = {
    init() {
        const elements = document.querySelectorAll('.js-slider-teaser');

        if (!elements.length) return;

        elements.forEach((element) => {
            const Slider = slider.default;
            const newOptions = defaultOptions;

            const container = element.querySelector('.slider-container');
            const descriptions = element.querySelectorAll('.js-image-slider-desc');
            const {slidesperview, autoplay, loop, speed, gap, grabCursor} = container.dataset;
            if (parseInt(slidesperview, 10) > 0) {
                newOptions.breakpoints = {};
                newOptions.slidesPerView = slidesperview;
            }

            newOptions.navigation.prevEl = element.querySelector('.js-slider-teaser-prev');
            newOptions.navigation.nextEl = element.querySelector('.js-slider-teaser-next');

            if (autoplay === '1') {
                newOptions.autoplay = true;
                const speedDecimal = parseInt(speed, 10);
                newOptions.speed = speedDecimal > 0 ? speedDecimal : 2000;
            }

            if (loop === '1') {
                newOptions.loop = true;
            }

            if (grabCursor === '1') {
                newOptions.grabCursor = true;
            }

            if (gap) {
                newOptions.spaceBetween = parseInt(gap, 10);
            }

            if (descriptions) {
                newOptions.on = {
                    init() {
                        descriptions.forEach((item) => {
                            const thumbnail = item.parentElement.querySelector('.js-image-slider-thumbnail');
                            const width = thumbnail.clientWidth;
                            if (width) {
                                // eslint-disable-next-line no-param-reassign
                                item.style.maxWidth = `${width}px`;
                            }
                        });
                    },
                };
            }

            this.sliderTeaser = new Slider(container, newOptions);
        });
    },
};

export default sliderTeaser;
